import settingsActionCreatorFactory from 'typescript-fsa'
import {
  EventLocationResponse,
  EventMemberResponse,
  EventPriceCategoryResponse,
  EventResponse,
  EventResultObject,
  MemberResponse,
  RelationResponse,
  StatisticResponse,
} from '../../shared/types'

export const dataActionCreator = settingsActionCreatorFactory('DATA')

/**
 * Actions
 */

// settings actions
export const setMembers = dataActionCreator<MemberResponse>('SET_MEMBERS')
export const setRelations = dataActionCreator<RelationResponse>('SET_RELATIONS')
export const setEvents = dataActionCreator<EventResponse>('SET_EVENTS')
export const setEventMember = dataActionCreator<EventMemberResponse>('SET_EVENT_MEMBER')
export const setEventPriceCategories = dataActionCreator<EventPriceCategoryResponse>('SET_EVENT_PRICE_CATEGORIES')
export const setEventLocations = dataActionCreator<EventLocationResponse>('SET_EVENT_LOCATIONS')
export const setEventResult = dataActionCreator<EventResultObject>('SET_EVENT_RESULT')
export const setStatistics = dataActionCreator<StatisticResponse>('SET_STATISTICS')
